import type { VehicleReference } from "@/features/vehicles/types/vehicle.types";
import type { Client } from "@/types/client.types";
import type { GpsLocation } from "@/types/location.types";
import type { Period } from "@/types/time.types";
import type { UserReference } from "@/types/user.types";

export interface Trip {
	batteryPercentageEnd?: number;
	batteryPercentageStart?: number;
	client?: Client;
	durationSeconds?: number;
	endPosition?: GpsLocation;
	id?: string;
	mileageDelta?: number;
	mileageEnd?: number;
	mileageStart?: number;
	period?: Period;
	route?: string;
	startPosition?: GpsLocation;
	user?: UserReference;
	vehicle?: VehicleReference;
	vehicleId?: string;
}

export type Triptype = (typeof Triptype)[keyof typeof Triptype];

export const Triptype = {
	PUBLIC: "PUBLIC",
	BUSINESS: "BUSINESS",
	COMMUTE: "COMMUTE",
	PRIVATE: "PRIVATE",
} as const;

export interface SearchTripRequest {
	vehicleIds?: Array<string>;
	clientIds?: Array<string>;
	userRemoteId?: string;
	period: Period;
}

